const colors: any = {
  black: '0,0,0',
  white: '255,255,255',
  'primary-500': '255,84,15', // ff540f
  'primary-300': '255,245,244', // #fff5f4
  'gray-800': '76,76,76', // #4c4c4d
  'gray-700': '93,93,93', // #5d5d5d
  'gray-500': '155,155,155', // #9b9b9b
  'gray-300': '219,219,219', // #dbdbdb
  'gray-200': '242,242,242', // #f2f2f2
}

const alphas: any = {
  '100': 1.0,
  '85': 0.85,
  '50': 0.5,
  '25': 0.25,
  '10': 0.1,
}

const theme = {
  variables: {
    rootPx: 16,
    headerHeight: 100,
    headerDesktopHeight: 50,
    footerHeight: 60,
    topBannerDesktopHeight: 520,
    topBannerMobileHeight: 577,
    topBannerMobileLargeHeight: 379,
    countryChangeBannerHeightInDesktop: 68,
    countryChangeBannerHeightInMobile: 110,
    contentMargin: 26,
    globalHeaderHeight: 48,
    topDownloadBannerHeight: 52,
  },
  width: {
    mobile: {
      default: 360,
      large: 600,
    },
    desktop: {
      small: 770,
    },
  },
  colors,
  alphas,
  fn: {
    color: (color = 'primary-500', alpha = '100'): string => {
      return `rgba(${colors[color]},${alphas[alpha]})`
    },
    rem: (px: number): string => {
      return `calc(var(--unit) * ${px})`
    },
  },
  mixin: {
    padding: `
            padding: 20px;
        `,
  },
  shadow(level: number): string {
    let css = ''

    if (level > 0) {
      css = `
                box-shadow: ${level}px ${level}px 2px rgba(0,0,0,0.5);
            `
    }

    return css
  },
  icon: {
    select(name: string): string {
      const code: any = this.code

      return `
            &:before {
                content: "${code[name]}";
            }
            `
    },
    default: `
            /* use !important to prevent issues with browser extensions that change fonts */
            font-family: 'icomoon' !important;
            speak: none;
            font-style: normal;
            font-weight: normal;
            font-variant: normal;
            text-transform: none;
            line-height: 1;

            /* Better Font Rendering =========== */
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;`,
    code: {
      event_off: '\\e900',
      event_on: '\\e901',
      hospital_off: '\\e902',
      hospital_on: '\\e903',
      sort_arrow: '\\e904',
      more: '\\e906',
      instagram: '\\e905',
      youtube: '\\e911',
      twitter: '\\e910',
      star: '\\e907',
      line: '\\e912',
      menu: '\\e913',
      guarantee: '\\e908',
      exit: '\\e909',
      column_on: '\\e90b',
      column_off: '\\e90c',
      download: '\\e90d',
      thin_arrow_left: '\\e90e',
      thin_arrow_right: '\\e90f',
      arrow_bottom: '\\e90a',
    },
    tags: {
      all_off: '/assets/icon/tags/all-off.svg',
      all_on: '/assets/icon/tags/all-on.svg',
      eye_off: '/assets/icon/tags/eye-off.svg',
      eye_on: '/assets/icon/tags/eye-on.svg',
      nose_off: '/assets/icon/tags/nose-off.svg',
      nose_on: '/assets/icon/tags/nose-on.svg',
      faceline_off: '/assets/icon/tags/faceline-off.svg',
      faceline_on: '/assets/icon/tags/faceline-on.svg',
      breast_off: '/assets/icon/tags/breast-off.svg',
      breast_on: '/assets/icon/tags/breast-on.svg',
      bodyline_off: '/assets/icon/tags/bodyline-off.svg',
      bodyline_on: '/assets/icon/tags/bodyline-on.svg',
      transplant_off: '/assets/icon/tags/transplant-off.svg',
      transplant_on: '/assets/icon/tags/transplant-on.svg',
      filler_off: '/assets/icon/tags/filler-off.svg',
      filler_on: '/assets/icon/tags/filler-on.svg',
      botox_off: '/assets/icon/tags/botox-off.svg',
      botox_on: '/assets/icon/tags/botox-on.svg',
      ac_off: '/assets/icon/tags/ac-off.svg',
      ac_on: '/assets/icon/tags/ac-on.svg',
      lifting_off: '/assets/icon/tags/lifting-off.svg',
      lifting_on: '/assets/icon/tags/lifting-on.svg',
      lip_off: '/assets/icon/tags/lip-off.svg',
      lip_on: '/assets/icon/tags/lip-on.svg',
      teethandoptical_off: '/assets/icon/tags/teethandoptical-off.svg',
      teethandoptical_on: '/assets/icon/tags/teethandoptical-on.svg',
      etc_off: '/assets/icon/tags/etc-off.svg',
      etc_on: '/assets/icon/tags/etc-on.svg',
    },
  },
}

export default theme
